export class Constants {
    // dates
    public static DATE_PARSE_FORMAT: string = 'YYYY-MM-DD';
    public static DATE_DISPLAY_FORMAT: string = 'MM/DD/YYYY';
    public static DATE_TRAMS_FORMAT: string = 'MMDDYYYY';

    // coverages
    public static COVERAGE_CFAR: string = 'CFAR';
    public static MULTIPLE_LIMIT_RATING_IDS: string[] = ['FAU'];
    public static CAR_RENTAL_RATING_IDS: string[] = [ "CRCC" ]; 

    
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/settings/constants.ts